import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'

import en from 'I18N/translations/en/common.json'
import fr from 'I18N/translations/fr/common.json'

const defaultNS = 'common'

const resources = {
    en: { common: en },
    fr: { common: fr },
}

i18next
    .use(initReactI18next)
    .init({
        resources,
        lng: document.documentElement.lang,
        fallbackLng: 'en',
        load: 'languageOnly',
        defaultNS,
        interpolation: {
            escapeValue: false,
        },
    })

export default i18next
